import React, { useEffect, useState } from 'react';
import { Card, Button, ProgressBar, Form, Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import loginbg from "../../../../images/login-bg-4.jpg";
import RenderStepContent from './RenderStep';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { registerUser, resetRegisterFlag } from '../../../../core/store/auth/register/thunk';
import { useNavigate } from 'react-router-dom';
import { resetRegisterFlagChange } from '../../../../core/store/auth/register/reducer';

const Objectifs = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 6;
  const navigate = useNavigate();


  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [selectedGoal, setSelectedGoal] = useState(null);
 

  const selectLayoutState = (state) => state;
   const registerpageData = createSelector(
         selectLayoutState,
         (state) => ({
             //user: account.user,
             errorMsg: state.Account.errorMsg,

           success: state.Account.success ,
        error: state.Account.error,
    })
     ); 
  // Inside your component
 const {
       user, error, errorMsg
   } = useSelector(registerpageData); 


   const validationSchemas = [
    Yup.object({
      firstname: Yup.string().required('First name is required'),
      lastname: Yup.string().required('Last name is required'),
    }),
    Yup.object({
      su_userGoalDto: Yup.object({
        weightGoalId: Yup.string().required('Weight goal is required'),
      }),
    }),
    Yup.object({
      su_activityLevel: Yup.string().required('Activity level is required'),
    }),
    // Yup.object({
    //   su_preferences: Yup.array().min(1, 'At least one preference must be selected'),
    // }),
    // Yup.object({
    //   su_recommandations: Yup.array().min(1, 'recommandation is required'),
    // }),
    Yup.object({
      gender: Yup.string().required('Gender is required'),
      dateOfBirth: Yup.string().required('Date of birth is required'),
    }),
    Yup.object({
      su_height: Yup.number().required('Height is required').positive('Height must be positive'),
      su_initialWeight: Yup.number().required('Initial weight is required').positive('Weight must be positive'),
    }),
    Yup.object({
      su_userGoalDto: Yup.object({
        method: Yup.string().required('Method is required'),
      }),
    }),
    Yup.object({
      email: Yup.string().email('Invalid email').required('Email is required'),
      password: Yup.string().min(4, 'Password must be at least 4 characters long').required('Password is required'),
    }),
];


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  dateOfBirth: '',
  gender: 'MALE',
  country:'string',
  userType: "standard",
  dc_specialization: "string",
  su_initialWeight: "",       // au lieu de null
  su_activityLevel: 'SEDENTARY',
  su_preferences: [],
  su_recommandations: [],
  su_equipmentAccess: true,
  dc_degree: "string",
  dc_siretOrSiren: "string",
  su_height: "",              // au lieu de null
  su_userGoalDto: {
    weightGoalId: "",         // au lieu de null
    method: "DIET",
  },
},
    validationSchema: validationSchemas[currentStep - 1],
    onSubmit: (values) => {
      dispatch(registerUser(values, navigate));
      console.log("donnes register", values)
      console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('Condition result:', !!process.env.REACT_APP_API_URL);
      setLoader(true);
    },
  });

  const nextStep = () => {
    if (currentStep === 2 && !selectedGoal) return; // Bloquer si aucun goal sélectionné
  setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
   
  };

  const prevStep = () => setCurrentStep(prev => Math.max(prev - 1, 1));

  

  useEffect(() => {
   
    if (errorMsg) {
        setTimeout(() => {
            dispatch(resetRegisterFlag());
            setLoader(false)

        }, 3000);
    }
}, [dispatch, errorMsg]);

  return (
    <div className="login-main-page" style={{ backgroundImage: "url(" + loginbg + ")", paddingTop: '100px' }}>
      <Container className="mt-5" style={{ minHeight: '70vh' }}>
        <Row className="justify-content-center" >
          <Col xs={12} md={12} lg={12}>
            <Card >
              <Card.Body>
                <ProgressBar now={(currentStep / totalSteps) * 100} className="mb-4" />
                {error && typeof error === 'string' && <Alert variant="danger">{error}</Alert>}
                {errorMsg && typeof errorMsg === 'string' && <Alert variant="danger">{errorMsg}</Alert>}
                <Form onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}>
                   {Object.keys(validation.errors).map((key) => (
                    <Alert key={key} variant="danger">
                      {validation.errors[key]}
                    </Alert>
                  ))}
                 {RenderStepContent(currentStep, validation.setFieldValue, validation.values, validation.handleChange, validation, selectedGoal, setSelectedGoal)}

                 
                </Form>
                <div className="d-flex justify-content-between mt-4">
                 {currentStep!==1 && <Button variant="outline-primary" onClick={prevStep} >RETOUR</Button>}
                  {currentStep === totalSteps ? (
                    <Button onClick={() => validation.handleSubmit()} disabled={loader}>
                      {loader && <Spinner size="sm" className='me-2' />}Soumettre
                    </Button>
                  ) : (
                    <Button onClick={nextStep}>Suivant</Button>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Objectifs;
